<template>
    <Header></Header>
    <div class="container">
        <div class="sub-tit">
            <menuTitle></menuTitle>
        </div>
        <div class="inner">
            <SearchAorta v-if="$store.state.hospStore.host === 'H0006'"></SearchAorta>
            <SearchAorta v-if="$store.state.hospStore.host === 'H0007'"></SearchAorta>
            <SearchMombaby v-if="$store.state.hospStore.host === 'H0008'"></SearchMombaby>
            <SearchBlood v-if="$store.state.hospStore.host === 'H0009'"></SearchBlood>
        </div>
    </div>
    <Footer></Footer>
</template>

<script>
    import Header from '@/components/kr/common/Header.vue';
    import SearchAorta from '@/components/kr/search/aorta/SearchPage.vue';
    import SearchBrain from '@/components/kr/search/ewhabrain/SearchPage.vue';
    import SearchMombaby from '@/components/kr/search/mombaby/SearchPage.vue';
    import SearchBlood from '@/components/kr/search/blood/SearchPage.vue';
    import Footer from '@/components/kr/common/Footer.vue';


    export default {
        components: {
            Header,
            SearchAorta,
            SearchBrain,
            SearchMombaby,
            SearchBlood,
            Footer
        },
        mounted() {
            
        },
    }
</script>
<style>
    /* @import url('../../assets/resource/css/sub.css'); */
</style>